import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { getCompanies } from '../services/getCompanies.service';

export const loadCompanies = createAsyncThunk(
  'expenseTracking/loadCompanies',
  async (params, { getState }) => {
    const project = selectSelectedProject(getState());
    const businessId = project?.business_id;

    if (!businessId) {
      return [];
    }

    const companies = [];
    let response;
    do {
      response = await getCompanies(businessId, response?.LastEvaluatedKey);
      if (response?.Items?.length) {
        companies.push(...response.Items);
      }
    } while (response?.LastEvaluatedKey);

    return companies;
  }
);
